module.exports = __webpack_public_path__ + "d308073b/img/grid-web-icon.d0395d64.svg";